import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.288 28.953a5 5 0 0 0 4.422 4.421c.419.046.849.09 1.29.13v3.45a3 3 0 0 0 5.103 2.139l5.224-5.135c.493.004.994.006 1.503.006 5.237 0 9.72-.2 13.45-.603a5 5 0 0 0 4.434-4.425C37.905 27.193 38 24.884 38 22c0-2.71-.084-5.078-.252-7.105a7 7 0 0 0-6.361-6.394A130.338 130.338 0 0 0 8.61 8.496a7 7 0 0 0-6.357 6.392C2.084 16.916 2 19.286 2 22c0 2.893.095 5.209.288 6.953Zm6.793 2.638a1 1 0 0 1 .919.997v4.365a1 1 0 0 0 1.7.713l5.52-5.424a1 1 0 0 1 .712-.287c.62.006 1.252.01 1.898.01 5.17 0 9.583-.198 13.236-.593a3 3 0 0 0 2.66-2.655c.182-1.659.274-3.9.274-6.717 0-2.659-.082-4.973-.245-6.94a5 5 0 0 0-4.544-4.566 128.322 128.322 0 0 0-22.424-.006 5 5 0 0 0-4.541 4.566C4.082 17.022 4 19.338 4 22c0 2.826.093 5.073.276 6.734a3 3 0 0 0 2.653 2.652c.686.076 1.403.144 2.152.205ZM28 38l-3.2-.001c-3.104-.002-4.306-.002-5.798.001a1 1 0 1 1-.004-2c1.495-.003 2.698-.003 5.802-.001L28 36c.708 0 1.408-.004 2.098-.013a1 1 0 0 1 .714.287l5.487 5.392A1 1 0 0 0 38 40.953V36.59a1 1 0 0 1 .917-.997c.751-.062 1.47-.131 2.154-.207a3 3 0 0 0 2.653-2.652C43.907 31.073 44 28.826 44 26c0-2.662-.082-4.978-.246-6.946a5.001 5.001 0 0 0-3.16-4.242 1 1 0 1 1 .73-1.862 7.001 7.001 0 0 1 4.423 5.938C45.916 20.916 46 23.286 46 26c0 2.893-.096 5.209-.288 6.953a5 5 0 0 1-4.422 4.421c-.418.046-.848.09-1.29.131v3.448a3 3 0 0 1-5.103 2.14l-5.19-5.102c-.564.006-1.133.009-1.707.009Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Chat-Outlined_svg__a",
      width: 44,
      height: 36,
      x: 2,
      y: 8,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M2.288 28.953a5 5 0 0 0 4.422 4.421c.419.046.849.09 1.29.13v3.45a3 3 0 0 0 5.103 2.139l5.224-5.135c.493.004.994.006 1.503.006 5.237 0 9.72-.2 13.45-.603a5 5 0 0 0 4.434-4.425C37.905 27.193 38 24.884 38 22c0-2.71-.084-5.078-.252-7.105a7 7 0 0 0-6.361-6.394A130.338 130.338 0 0 0 8.61 8.496a7 7 0 0 0-6.357 6.392C2.084 16.916 2 19.286 2 22c0 2.893.095 5.209.288 6.953Zm6.793 2.638a1 1 0 0 1 .919.997v4.365a1 1 0 0 0 1.7.713l5.52-5.424a1 1 0 0 1 .712-.287c.62.006 1.252.01 1.898.01 5.17 0 9.583-.198 13.236-.593a3 3 0 0 0 2.66-2.655c.182-1.659.274-3.9.274-6.717 0-2.659-.082-4.973-.245-6.94a5 5 0 0 0-4.544-4.566 128.322 128.322 0 0 0-22.424-.006 5 5 0 0 0-4.541 4.566C4.082 17.022 4 19.338 4 22c0 2.826.093 5.073.276 6.734a3 3 0 0 0 2.653 2.652c.686.076 1.403.144 2.152.205ZM28 38l-3.2-.001c-3.104-.002-4.306-.002-5.798.001a1 1 0 1 1-.004-2c1.495-.003 2.698-.003 5.802-.001L28 36c.708 0 1.408-.004 2.098-.013a1 1 0 0 1 .714.287l5.487 5.392A1 1 0 0 0 38 40.953V36.59a1 1 0 0 1 .917-.997c.751-.062 1.47-.131 2.154-.207a3 3 0 0 0 2.653-2.652C43.907 31.073 44 28.826 44 26c0-2.662-.082-4.978-.246-6.946a5.001 5.001 0 0 0-3.16-4.242 1 1 0 1 1 .73-1.862 7.001 7.001 0 0 1 4.423 5.938C45.916 20.916 46 23.286 46 26c0 2.893-.096 5.209-.288 6.953a5 5 0 0 1-4.422 4.421c-.418.046-.848.09-1.29.131v3.448a3 3 0 0 1-5.103 2.14l-5.19-5.102c-.564.006-1.133.009-1.707.009Z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Chat-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgChatOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChatOutlined_default = SvgChatOutlined;

export { ChatOutlined_default as default };
